import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import type {
  ProductReviewEligibility,
  ProductReviewListItem,
  ProductReviewsPage,
} from './product-reviews.model';

export interface SubmitProductReviewPayload {
  productCatalogId: number;
  rating: number;
  body?: string;
  images: File[];
  video?: File | null;
  videoThumbnail?: File | null;
  videoDurationSeconds?: number | null;
}

@Injectable({
  providedIn: 'root',
})
export class ProductReviewsService {
  private readonly http = inject(HttpClient);
  private readonly storefrontUrl = `${environment.apiUrl}Storefront`;
  private readonly accountUrl = `${environment.apiUrl}CustomerAccount`;

  getProductReviews(catalogId: number, pageNumber = 1, pageSize = 20): Observable<ProductReviewsPage> {
    const params = new HttpParams()
      .set('catalogId', String(catalogId))
      .set('pageNumber', String(pageNumber))
      .set('pageSize', String(pageSize));

    return this.http.get<ProductReviewsPage>(`${this.storefrontUrl}/GetProductReviews`, { params });
  }

  getProductReviewEligibility(catalogId: number): Observable<ProductReviewEligibility> {
    const params = new HttpParams().set('catalogId', String(catalogId));
    return this.http.get<ProductReviewEligibility>(`${this.accountUrl}/GetProductReviewEligibility`, { params });
  }

  submitReview(payload: SubmitProductReviewPayload): Observable<ProductReviewListItem> {
    const form = new FormData();
    form.append('productCatalogId', String(payload.productCatalogId));
    form.append('rating', String(payload.rating));

    if (payload.body?.trim()) {
      form.append('body', payload.body.trim());
    }

    for (const image of payload.images) {
      form.append('images', image, image.name);
    }

    if (payload.video) {
      form.append('video', payload.video, payload.video.name);
      if (payload.videoThumbnail) {
        form.append('videoThumbnail', payload.videoThumbnail, payload.videoThumbnail.name);
      }
      if (payload.videoDurationSeconds != null) {
        form.append('videoDurationSeconds', String(Math.ceil(payload.videoDurationSeconds)));
      }
    }

    return this.http.post<ProductReviewListItem>(`${this.accountUrl}/SubmitProductReview`, form);
  }
}
